import { render } from "./campaignDetailsTeams.vue?vue&type=template&id=2ee78c17&scoped=true"
import script from "./campaignDetailsTeams.vue?vue&type=script&lang=js"
export * from "./campaignDetailsTeams.vue?vue&type=script&lang=js"

import "./campaignDetailsTeams.vue?vue&type=style&index=0&id=2ee78c17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee78c17"]])

export default __exports__